import oRequest from '@/libsV2/request.js';
const URL = {
    MODULE_ALL:'board/index/channel',//统计模块
    MODULE_SINGLE:'board/index/overview',//模块方格数据
    BORD_MAP_CITY:'board/index/map',//口碑地图大区维度数据
    BORD_MAP_CONTENT:'board/index/topicpage',//口碑地图大口碑内容维度数据
    MAP_CASE:'board/index/mapview',//口碑地图案例数据
    VERTICAL_MEDIUM:'board/index/vertical',//垂媒数据
    PRODUCT_CITY:'board/index/goods',//产品中心大区维度信息
    PRODUCT_CONTENT:'board/index/goodspage',//产品内容维度数据
    BEHAVIOR:'board/index/behavior',//靓导购
    PRAISE:'board/index/praise',//智慧案例发布数据
    USER_BEHAVIOR:'board/index/userbehavior',//客户行为
    WISDOM_MAP:'board/index/delivery',//直销员智慧集成口碑数据
    JF_DATA:'board/index/jiaofudata',//智慧集成交付数据
    PROJECT_PRAISE:'board/index/projectpraise',//智慧集成系统口碑数据
    PROJECT_VIEW:'board/index/projectview',//智慧集成系统口碑数据--表格
    JF_SYSTEM:'board/index/jiaofudata',//智慧集成交付数据
    CATEGORY:'board/index/category',//分品类榜单
    CONFIG:'board/index/config',//大区,省份筛选配置
    CATEGORY_INFO:'board/index/categorypage',//分品类详情接口
    DEAL_POST:'/board/index/deal',//提交备注
    AUTH:'/board/index/auth',//权限判断
}

export default{
    auth(data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.AUTH,oData)
    },
    dealPost(data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.DEAL_POST,oData)
    },
    categoryInfo(data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.CATEGORY_INFO,oData)
    },
    config(data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.CONFIG,oData)
    },
    category(data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.CATEGORY,oData)
    },
    jfSystem(data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.JF_SYSTEM,oData)
    },
    projectView(data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.PROJECT_VIEW,oData)
    },
    projectParise(data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.PROJECT_PRAISE,oData)
    },
    jfData(data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.JF_DATA,oData)
    },
    wisdomMap(data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.WISDOM_MAP,oData)
    },
    userBehavior(data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.USER_BEHAVIOR,oData)
    },
    praise(data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.PRAISE,oData)
    },
    behavior(data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.BEHAVIOR,oData)
    },
    productContent(data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.PRODUCT_CONTENT,oData)
    },
   productCity (data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.PRODUCT_CITY,oData)
    },
    verticalMedium(data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.VERTICAL_MEDIUM,oData)
    },
    mapCase(data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.MAP_CASE,oData)
    },
    bordMapContent(data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.BORD_MAP_CONTENT,oData)
    },
    bordMapCity(data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.BORD_MAP_CITY,oData)
    },
    allModule(data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.MODULE_ALL,oData)
    },
    singleModule(data={}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.MODULE_SINGLE,oData)
    },
}
